import Header from "./Header";
import Footer from "./Footer";
import BottomNav from "./BottomNav";
import PWAInstallPrompt from "./PWAInstallPrompt";
import { Toaster } from "./ui/sonner";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer />
      <BottomNav />
      <PWAInstallPrompt />
      <Toaster position="top-right" richColors />
    </div>
  );
}
